import React, { FC } from 'react'

import { useFormContext } from 'react-hook-form'

import ErrorMessage from 'Components/ErrorMessage'

import FormErrors from '../../FormErrors'

interface Props {
  handleResend: () => void
}
const Code: FC<Props> = ({ handleResend }) => {
  const { register, errors } = useFormContext()

  return (
    <div className="ml-3">
      <div className="form-group mb-2">
        <label className="col-sm-24 mb-0" htmlFor="customer-code">
          We have sent the authorization code to your number.
        </label>
        <input
          ref={register({ required: 'Code is required' })}
          autoComplete="one-time-code"
          className="form-control"
          id="customer-code"
          name="code"
          placeholder="Enter Code From SMS"
          type="number"
        />
        <ErrorMessage as={FormErrors} errors={errors} name="code" />
      </div>
      <div className="d-flex align-items-center">
        <a className="ml-1 text-underline" onClick={handleResend}>
          Resend code
        </a>
      </div>
    </div>
  )
}

export default Code
